import React from "react";
import { Outlet,useLocation } from "react-router-dom";
import Tabs from "../../../components/common/Tabs";

const tabs = [
  {
    link: "/accounting/receivables_payments/reciepts",
    title: "Receipts",
  },
  {
    link: "/accounting/receivables_payments/invoices",
    title: "Charges",
  },
  {
    link: "/accounting/receivables_payments/bank_deposits",
    title: "Bank Deposits",
  },

];

function Receivables() {
  const location = useLocation();
  return (
    <>
     {location.pathname === "/accounting/receivables_payments/chargelatefees" ? "" :  <Tabs tabs={tabs} style={{margin: "6px"}}/>}
     <Outlet />
    </>
  );
}

export default Receivables;